// extracted by mini-css-extract-plugin
export default {"productGallery":"KJ-z","inQuickShop":"LJ-z"};